import { render, staticRenderFns } from "./editPreimumDialog.vue?vue&type=template&id=04aa4b7c&scoped=true&"
import script from "./editPreimumDialog.vue?vue&type=script&lang=js&"
export * from "./editPreimumDialog.vue?vue&type=script&lang=js&"
import style0 from "./editPreimumDialog.vue?vue&type=style&index=0&id=04aa4b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa4b7c",
  null
  
)

export default component.exports